import { SVGComponentProps } from "./utils/Types"

const MapIcon = ({
    width = 27,
    height = 27,
    className,
}: SVGComponentProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 27 27"
            xmlns="http://www.w3.org/2000/svg"
            className={`text-current ${className}`}
        >
            <g clipPath="url(#clip0_0_80)">
                <path
                    d="M13.5037 23.3295L18.9685 17.8647C20.0492 16.7839 20.7852 15.4069 21.0833 13.9078C21.3814 12.4087 21.2283 10.8549 20.6434 9.44285C20.0584 8.03078 19.0679 6.82387 17.7971 5.97474C16.5262 5.1256 15.0321 4.67238 13.5037 4.67238C11.9753 4.67238 10.4812 5.1256 9.2103 5.97474C7.93944 6.82387 6.94892 8.03078 6.36398 9.44285C5.77904 10.8549 5.62595 12.4087 5.92408 13.9078C6.2222 15.4069 6.95815 16.7839 8.03886 17.8647L13.5037 23.3295ZM13.5037 26.4517L6.47779 19.4258C5.08822 18.0362 4.14192 16.2657 3.75854 14.3383C3.37517 12.4109 3.57194 10.4131 4.32398 8.59756C5.07602 6.78199 6.34955 5.2302 7.98352 4.13842C9.61749 3.04663 11.5385 2.4639 13.5037 2.4639C15.4688 2.4639 17.3899 3.04663 19.0238 4.13842C20.6578 5.2302 21.9313 6.78199 22.6834 8.59756C23.4354 10.4131 23.6322 12.4109 23.2488 14.3383C22.8655 16.2657 21.9191 18.0362 20.5296 19.4258L13.5037 26.4517ZM13.5037 14.6079C14.0893 14.6079 14.6509 14.3752 15.065 13.9612C15.4791 13.5471 15.7117 12.9855 15.7117 12.3999C15.7117 11.8143 15.4791 11.2526 15.065 10.8386C14.6509 10.4245 14.0893 10.1919 13.5037 10.1919C12.9181 10.1919 12.3565 10.4245 11.9424 10.8386C11.5283 11.2526 11.2957 11.8143 11.2957 12.3999C11.2957 12.9855 11.5283 13.5471 11.9424 13.9612C12.3565 14.3752 12.9181 14.6079 13.5037 14.6079ZM13.5037 16.8159C12.3325 16.8159 11.2092 16.3506 10.3811 15.5225C9.55292 14.6943 9.08766 13.5711 9.08766 12.3999C9.08766 11.2287 9.55292 10.1054 10.3811 9.27726C11.2092 8.4491 12.3325 7.98384 13.5037 7.98384C14.6749 7.98384 15.7981 8.4491 16.6263 9.27726C17.4545 10.1054 17.9197 11.2287 17.9197 12.3999C17.9197 13.5711 17.4545 14.6943 16.6263 15.5225C15.7981 16.3506 14.6749 16.8159 13.5037 16.8159Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_0_80">
                    <rect
                        width="26.4961"
                        height="26.4961"
                        transform="translate(0.255676 0.255798)"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default MapIcon
